import { createAsyncThunk } from "@reduxjs/toolkit";

import { ThunkConfig } from "@/app/providers/StoreProvider";
import { handleError } from "@/shared/lib/helpers/utils";
import { ApiError } from "@/shared/types";

import type { ProductData } from "../types/productData";

export const fetchProducts = createAsyncThunk<ProductData[], AbortSignal | undefined, ThunkConfig<ApiError>>(
  "subscription/fetchProducts",
  async (signal, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
      const response = await extra.api.get<ProductData[]>("/api/products", {
        signal,
      });

      return response.data;
    } catch (err) {
      return rejectWithValue(handleError(err));
    }
  }
);
